import React, { useEffect, useState } from "react"
import MainContainer from "../../components/MainContainer"
import MainHeader from "../../components/MainHeader"
import Title from "../../components/Title"
import {
    Box,
    Button,
    Grid2,
    Slider,
    Switch,
    TextField,
    Typography,
} from "@mui/material"
import { toast } from "react-toastify"
import api from "../../services/api"

function Suggestions() {
    const [enable, setEnable] = useState(false)
    const [temperature, setTemperature] = useState(0.4)
    const [prompt, setPrompt] = useState("")
    const [maxTokens, setMaxTokens] = useState(60)

    const handleSaveSettings = async (key, value) => {
        try {
            await api.put(`/settings/${key}`, {
                value,
            })
            toast.success("Configurações salvas com sucesso")
        } catch (error) {
            toast.error("erro ao salvar configuraçoes")
        }
    }

    async function getSettings() {
        try {
            const { data } = await api.get(`/settings`)

            const suggestionsEnabledByClient = data.find(
                (item) => item.key === "suggestionsEnabledByClient",
            )
            const suggestionsTemperature = data.find(
                (item) => item.key === "suggestionsTemperature",
            )
            const suggestionsPrompt = data.find(
                (item) => item.key === "suggestionsPrompt",
            )
            const suggestionsMaxTokens = data.find(
                (item) => item.key === "suggestionsMaxTokens",
            )

            setEnable(
                suggestionsEnabledByClient?.value === "false" ? false : true,
            )
            setTemperature(suggestionsTemperature?.value)
            setPrompt(suggestionsPrompt?.value)
            setMaxTokens(suggestionsMaxTokens?.value)
        } catch (error) {
            toast.error("Erro ao buscar configurações")
        }
    }

    useEffect(() => {
        getSettings()
    }, [])

    const handleChangeEnable = (state) => {
        setEnable(state)
        handleSaveSettings("suggestionsEnabledByClient", `${state}`)
    }

    return (
        <MainContainer>
            <MainHeader>
                <Title>Configurações de sugestão</Title>
            </MainHeader>

            <Grid2 container>
                <Grid2 size={{ xs: 12 }}>
                    <Box mb={2}>
                        <Typography>Habilitar sugestões</Typography>
                        <Switch
                            defaultChecked
                            checked={enable}
                            onChange={(e) =>
                                handleChangeEnable(e.target.checked)
                            }
                        />

                        <Typography>Temperatura: {temperature}</Typography>
                        <Slider
                            min={0}
                            max={2}
                            step={0.1}
                            value={temperature}
                            onChange={(e) => setTemperature(e.target.value)}
                            sx={{ maxWidth: 400, ml: 3 }}
                            onBlur={(e) =>
                                handleSaveSettings(
                                    "suggestionsTemperature",
                                    e.target.value,
                                )
                            }
                        />

                        <Box>
                            <TextField
                                value={maxTokens}
                                onChange={(e) => setMaxTokens(e.target.value)}
                                label="Máximo de caracteres"
                                placeholder="Escolha um valor até 140"
                                type="number"
                                id="outlined-textfield"
                                sx={{
                                    mb: 2,
                                    mt: 2,
                                    minWidth: 180,
                                }}
                                onBlur={(e) =>
                                    handleSaveSettings(
                                        "suggestionsMaxTokens",
                                        e.target.value,
                                    )
                                }
                                slotProps={{
                                    htmlInput: {
                                        min: 40,
                                        max: 140,
                                    },
                                }}
                            />

                            <TextField
                                fullWidth
                                id="outlined-textarea"
                                label="Prompt"
                                placeholder="Max 300 caracteres"
                                multiline
                                value={prompt}
                                onChange={(e) => setPrompt(e.target.value)}
                                slotProps={{
                                    htmlInput: {
                                        maxLength: 300,
                                    },
                                }}
                            />

                            <Button
                                sx={{ mt: 2 }}
                                variant="contained"
                                onClick={() =>
                                    handleSaveSettings(
                                        "suggestionsPrompt",
                                        prompt,
                                    )
                                }
                            >
                                Salvar
                            </Button>
                        </Box>
                    </Box>
                </Grid2>
            </Grid2>
        </MainContainer>
    )
}

export default Suggestions
